export default build =>
    build.mutation({
        query(payload) {
            console.log("payload",payload)
            return {
                url: '/course/updateLessonName',
                method: 'POST',
                body: payload,
            };
        },
        invalidatesTags: ['courseById'],
       
    })
